// extracted by mini-css-extract-plugin
export default {"container":"T2-z"};